import { ToggleItem, LineChartIcon, BarChartIcon } from "@flat-ui";
import { DailyMetricDataPoint } from "@components/analytics/in-house/utils/analytics-utils";

/** Supported chart visualization modes for the analytics chart switcher. */
export type AnalyticsChartType = "line" | "bar";

/** Toggle options displayed in the analytics chart type selector. */
export const ANALYTICS_CHART_TOGGLE_ITEMS: ToggleItem<AnalyticsChartType>[] = [
  {
    label: "Line chart",
    value: "line",
    icon: <LineChartIcon />,
  },
  {
    label: "Bar chart",
    value: "bar",
    icon: <BarChartIcon />,
  },
];

export interface AnalyticsChartProps {
  /** Chart points already aggregated per day and formatted for the X-axis. */
  dataset: DailyMetricDataPoint[];

  /** Step used to reduce the amount of visible X-axis tick labels. */
  xTickStep: number;

  /** Label rendered next to the Y-axis. */
  yAxisLabel: string;

  /** Unit suffix displayed in the series tooltip values. */
  seriesUnitLabel: string;
}
